import { render } from "./SearchDocument.vue?vue&type=template&id=72f4f28c&scoped=true"
import script from "./SearchDocument.vue?vue&type=script&lang=js"
export * from "./SearchDocument.vue?vue&type=script&lang=js"

import "./SearchDocument.vue?vue&type=style&index=0&id=72f4f28c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f4f28c"]])

export default __exports__